import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
export const ChipItem = (param)=>{
    let { children , bgColor , color  } = param;
    return /*#__PURE__*/ _jsx(Chip, {
        style: {
            backgroundColor: bgColor,
            color: color
        },
        children: children
    });
};
export const Chip = styled("span")((param)=>{
    let { theme  } = param;
    return {
        padding: "2px 8px",
        borderRadius: "4px",
        marginBottom: "8px",
        display: "inline-block",
        ...theme.typography.subtitle2
    };
});
export const KeywordChip = (param)=>{
    let { text , onClick  } = param;
    return /*#__PURE__*/ _jsxs(Typography, {
        onClick: onClick,
        component: "li",
        variant: "subtitle1",
        sx: (theme)=>{
            return {
                backgroundColor: "#fff",
                color: theme.palette.secondary["main"],
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid ".concat(theme.palette.grey[200]),
                cursor: "pointer",
                display: "flex",
                "&:hover": {
                    backgroundColor: theme.palette.grey[50]
                }
            };
        },
        children: [
            "#",
            /*#__PURE__*/ _jsx(Typography, {
                variant: "body1",
                sx: (theme)=>{
                    return {
                        marginLeft: "6px",
                        color: theme.palette.text["title"]
                    };
                },
                children: text
            })
        ]
    });
};
